

















 /* ----------------------------------------
    Modules
 ---------------------------------------- */

 import anime from 'animejs';

 /* ----------------------------------------
     Types
 ---------------------------------------- */

 import { Component, Prop, Vue } from 'vue-property-decorator';

 /* ----------------------------------------
     Mixin
---------------------------------------- */

 import { componentMixin } from './../../mixins/component';
 import { FormMixin } from './../../mixins';

 /* ----------------------------------------
     Component
 ---------------------------------------- */

 @Component({
     name: 'picklist',
     data() {
         return {
             active: false,
             selected: [],
             aliasNames: [
                 'holder',
                 'info',
                 'input',
                 'options',
                 'option',
                 'label'
             ],
             type: 'checkbox'
         };
     },
     props: {
         multi: Boolean,
         options: Array,
         single: Boolean,
     },
     mixins: [
         componentMixin,
         FormMixin
     ],
     computed: {
         amount() {
             return this.multi && this.selected.length;
         }
     },
     methods: {
         isSelected(option) {
             return this.selected.indexOf(option) > -1;
         },
         toggle() {
             this.active = !this.active;

             const el = this.$el;
             const target = el.querySelector('.vv-picklist__options');
             const item = el.querySelector('.vv-picklist__option');

             const itemHeight = item.offsetHeight;

             const animation = [0, itemHeight * this.options.length];
             const value = this.active ? animation : animation.reverse();

             anime({
                 targets: target,
                 height: value,
                 duration: 350,
                 easing: 'easeInOutQuad'
             })
         }
     },
     mounted() {
         if(this.multi)
             this.type = 'checkbox';

         if(this.single)
             this.type = 'radio';
     }
 })

 /* ----------------------------------------
     Export
 ---------------------------------------- */

 export default class FormPicklist extends Vue {}

